// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mc3M","tabsBox":"styles_tabsBox__VNYV-","createButton":"styles_createButton__2NsIw"};